<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div v-if="isDemo()" class="commingSoon">
        <div class="commingSoonMessage">
          Coming Soon
        </div>
      </div><!-- /main-->
      
      <div v-else>
      
        <div class="exhMessage">
          <div class="exhMessageMov">
            <h2>メッセージ</h2>
            <p class="subH2">message</p>
            <div class="exhMessageMovBody">
              <div class="mov01">
                <a><img @click="openVideoDialog" data-id="1" class="" src="/img2021/aboutMovieKaji.jpg" srcset="/img2021/aboutMovieKaji@2x.jpg 2x" alt="写真展メッセージ「梶裕貴」篇" /></a>
              </div>
              <div class="mov02">
                <a><img @click="openVideoDialog" data-id="2" class="" src="/img2021/aboutMovieIshikawa.jpg" srcset="/img2021/aboutMovieIshikawa@2x.jpg 2x" alt="写真展メッセージ「石川由依」篇" /></a>
              </div>
              <div class="mov03">
                <a><img @click="openVideoDialog" data-id="3" class="" src="/img2021/aboutMovieComplete.jpg" srcset="/img2021/aboutMovieComplete@2x.jpg 2x" alt="写真展メッセージ 完全版「梶裕貴・石川由依」篇" /></a>
              </div>
            </div><!-- /exhMessageMovBody-->
          </div><!-- /exhMessageMov-->

          <div class="exhMessageTxt">

            <div class="exhMessageTxtMenu">
              <a :class="{ select: lang === 'ja' }" @click="lang='ja'" href="javascript:void(0)">Japanese</a><a @click="lang='en'" :class="{ select: lang === 'en' }" href="javascript:void(0)">English</a>
            </div><!-- /exhMessageTxtMenu-->


            <div class="exhMessageTxtBody">
              <div class="msgJp" :class="{ msgHidden: lang=='en' }">
                共感出来なくとも共存できる<br>
                分かり合えなくとも分かち合える<br>
                そう信じていたけれど<br>
                議論という名の誹謗中傷<br>
                正義という名の私刑執行<br>
                マナーという名の自粛警察<br>
                寛容が死に絶えた世界<br>
                だから…、絶望したくなる<br>
                <br>
                ある日、カメラと出会った<br>
                写真好きと語らうようになった<br>
                被写体を探すようになった<br>
                窓から差し込む光<br>
                ビルの反射<br>
                赤い傘<br>
                雨の水たまり<br>
                歩く、家族の後ろ姿<br>
                色の濃い夕焼け<br>
                沸き立つ雲<br>
                すべてが最高の被写体<br>
                見ていなかった世界との出会い<br>
                だから、気づいた<br>
                <br>
                好きな香りのコーヒーを見つけた<br>
                近所の猫が遊びに来た<br>
                唐揚げがいつもよりおいしくできた<br>
                「おはよう」の挨拶ができた<br>
                本屋で愛読書の続編を見つけた<br>
                推しの漫画がアニメ化した<br>
                目の前の席が、空いて座れた<br>
                日常は小さくとも愛おしく幸せにあふれていた<br>
                だから…、カメラをもって出かけよう<br>
                <br>
                人生から退屈を退治しよう<br>
                写真を見せ合おう<br>
                友人と語り合おう<br>
                家族と寄り合おう<br>
                好きな人に思いを伝えよう<br>
                「月が…キレイ」<br>
                ああ、そうだ…<br>
                だから…、世界は…美しい<br>
                <br>
                東京カメラ部2021写真展 online開幕<br>
                ～写真との出会いは世界との出会いだ～<br>
              </div>
              <div class="msgEn" :class="{ msgHidden: lang=='ja' }">
              We can coexist without empathy<br>
We can share our thoughts without understanding each other<br>
―That's what I used to believe<br>
We see people slandering others in the name of debate<br>
People lynching others in the name of justice<br>
People abusing others in the name of order<br>
Tolerance can be found nowhere in this world<br>
―That's why... I feel so hopeless<br>
<br>
One day, I took a camera in hand<br>
I started chatting with enthusiasts of photography<br>
And I began to look for subjects:<br>
Light shining through a window<br>
Reflection on a building<br>
Red umbrella<br>
Rain puddle<br>
Backs of a family walking away<br>
Vivid sunset<br>
Boiling clouds<br>
Everything became a special subject<br>
I met a world that I had not yet seen<br>
―And then I began to realize:<br>
<br>
I found coffee with the perfect aroma<br>
The neighbor's cat came to visit me<br>
My fried chicken turned out better than usual<br>
We said “Hello” to each other for the first time<br>
I found the sequel to my favorite book at the bookstore<br>
My favorite manga became an anime<br>
The seat in front opened up, and I was able to take a seat<br>
―Every day was filled with small but precious and happy moments<br>
So... take a camera in hand<br>
<br>
Let's eradicate boredom from our lives<br>
Let's share with each other our photos<br>
Let's talk with our friends<br>
Let’s get together with our family<br>
Let's tell our beloved one…<br>
“The moon is beautiful, isn't it?”<br>
Ah, yes...<br>
That's why... the world is... beautiful<br>
<br>
Tokyo Camera Club 2021 Online Exhibition Begins<br>
～An encounter with a photo is an encounter with the world～<br>
              </div>
            </div><!-- /exhMessageTxtBody-->
          </div><!-- /exhMessageTxt-->

          <div class="exhAbout">

            <div class="aboutJp">

              <h2>開催概要</h2>

              <p class="exhDate">開催期間<br> 2021/11/3（水・祝）～2021/12/11（土）<br></p>

              <p class="mainTxt">
              2020年に東京カメラ部とその分室で11億人<sup>*1</sup>を超える人々が約3,300万作品<sup>*2</sup>の中から選んだ作品「10選2020」を中心に新作、自信作を追加。更に2012年、2013年、2014年、2015年、2016年、2017年、2018年、2019年に選ばれた10選メンバーを加えた、10選9世代による合同展示です。<br>
              <br>
              本展示の開催は今年で9回目となります。過去7回目までは、都内にて大規模展示を開催し日本全国から大勢の方にお越しいただいてきましたが、昨年8回目に引き続き今年も、新型コロナウイルス感染症（COVID-19）対策としてオンラインでの開催とさせていただきました。<br>
              <br>
              また、新型コロナウイルス感染症（COVID-19）の影響により甚大な被害を受けた日本全国の名勝地、観光業の支援の要素をより強くするため日本全国名勝地の四季写真を募集したフォトコンテスト「日本写真100景＜四季＞2021」の入選作品、多様な文化視点で捉えた日本の写真を募集した「Japan Travel Gallery Photo Contest」の入選作品、東京カメラ部Weiboアカウントにて開催した“私がおススメしたい絶景”がテーマのフォトコンテスト入選作品と東京カメラ部Weiboアカウントへのご投稿作品から選ばれた作品、さらには東京カメラ部Twitterフォトコンテストの入選作品も加え、昨年の倍以上の約634作品を展示します。<br>
              <br>
              当サイトから、オンラインですべての作品をご覧いただくことや出展者へのコメントを通じた出展者の方との交流が可能となっています。また、オンライントークショーなども予定をしています。さらに、一部の出展者の方については、みなさまへのメッセージや、展示作品以外の作品もご覧いいただくこともできますので、時間、場所を気にせず、ゆっくりとお楽しみいただけますと幸いです。
              </p>
              <p class="attention">
                <sup>*1</sup> 11億人:東京カメラ部とその分室がタイムラインで紹介している作品の2020年延べリーチ（閲覧者）数（Facebook、Instagram、Twitter、Weiboインサイト）に基づく<br>
                <sup>*2</sup> 約3,300万作品：2020年末迄に東京カメラ部とその分室に投稿いただいた総作品数
              </p>

              <div class="aboutJpMov">
                <h3>東京カメラ部顧問 出井伸之よりのメッセージ</h3>
                <a><img @click="openVideoDialog" data-id="0" class="" src="/img2021/topMovieEdei@2x.jpg"  alt="出井伸之よりのメッセージ" /></a>
              </div>

            </div><!-- /aboutJp-->


            <div class="aboutEn">

              <h2>ABOUT</h2>

              <p class="exhDate">Exhibition Schedule:<br> November 3rd, 2021 (Wed.) ～ <br>December 11th, 2021 (Sat.)<br></p>

              <p class="mainTxt">
              Tokyo Camera Club's “10 Photos of 2020” are a selection by more than 1.1 billion fans<sup>*1</sup> of Tokyo Camera Club and its sister accounts amongst approximately 33 million photos<sup>*2</sup>. At this joint exhibition, the photographers of the “10 Photos of 2020” will be presenting their selected photos along with some of their new and most proud works, in addition to the works of eight generations of the "10 Photographers" from 2012, 2013, 2014, 2015, 2016, 2017, 2018, and 2019.<br>
              <br>
              This year marks the ninth year of the Tokyo Camera Club Photo Exhibition. Up until the seventh exhibition, we hosted a large-scale exhibition in Tokyo, attracting thousands of visitors from all over Japan. However, following the 8th photo exhibition, we have decided to hold the exhibition online to prevent the spread of the novel coronavirus disease (COVID-19).<br>
              <br>
              In addition to the works of the 10 Photographers, we will also be exhibiting:<br>
              </p>
              <ul>
              <li>The winning works of the “100 Cultural & Landscape Photos of Japan -Seasons- 2021” Photo Contest, a photo contest we held to support the scenic spots and tourist industry throughout Japan that were severely affected by the novel coronavirus disease (COVID-19)</li>
              <li>The winning works of the “Japan Travel Gallery Photo Contest,” which capture Japan's beauty from diverse cultural perspectives</li>
              <li>The winning works of the Tokyo Camera Club Weibo Photo Contest held under the theme “Scenic spots I recommend visiting”</li>
              <li>The winning works of the Tokyo Camera Club Twitter Photo Contest</li>
              </ul>
              <p class="mainTxt">
              A total of 634 works will be exhibited this year, which is more than twice the amount from last year.<br>
              <br>
              On our exhibition website, you can view every photo online and even interact with the photographers by commenting on their work. There will also be online talk shows for you to enjoy. Many of the photographers will be posting messages and will have their portfolios available for you to see. Please enjoy the exhibition at your leisure, without worrying about time and place.<br>
              </p>
              <p class="attention">
                <sup>*1</sup> 1.1 billion fans: Based on the total number of viewers of photos shared on Tokyo Camera Club and its sister accounts' timelines (Facebook, Instagram, Twitter, Weibo insight)<br>
                <sup>*2</sup> 33 million photos: Number of photos posted on Tokyo Camera Club and its sister accounts by the end of 2020
              </p>

            </div><!-- /aboutEn-->


         </div><!-- /exhAbout-->

        </div><!-- /exhMessage-->











      </div>
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>

    <YoutubeDialog :isOpen.sync="videoDialog1" url="https://www.youtube.com/embed/0C5hY9do9gw"></YoutubeDialog>
    <YoutubeDialog :isOpen.sync="videoDialog2" url="https://www.youtube.com/embed/uTq6DIIPsc8"></YoutubeDialog>
    <YoutubeDialog :isOpen.sync="videoDialog3" url="https://www.youtube.com/embed/z7S7__SDgmc"></YoutubeDialog>
    <YoutubeDialog :isOpen.sync="videoDialog4" url="https://www.youtube.com/embed/lDa-mjTHG0k"></YoutubeDialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'
import YoutubeDialog from '@/components/modules/YoutubeDialog.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton,
    YoutubeDialog
  },
  data () {
    return {
      lang: 'ja',
      videoDialog1: false,
      videoDialog2: false,
      videoDialog3: false,
      videoDialog4: false,
    }
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    getArtworksCode (winner) {
      if (!this.awardTypeCode || !winner) return
      return this.awardTypeCode[winner.awardType]
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    openVideoDialog (e) {
      const id = e.currentTarget.getAttribute('data-id')
      this.videoDialog1 = (id === "0")
      this.videoDialog2 = (id === "1")
      this.videoDialog3 = (id === "2")
      this.videoDialog4 = (id === "3")

      this.$ga.event('YouTube', 'open', id, null)
    }
  },
  created () {},
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.commingSoon {
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.commingSoonMessage {
  margin-top: -24px;
  text-align: center;
  font-size: 3rem;
  width: 600px;
}
</style>
